export const constants = {
	selector: {
		target: 'data-expression-finder',
		handler: 'data-expression-finder-handler',
		color: 'data-expression-finder-color',
	},
}
